import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { postPaymentData } from "@services/paymentMethods.service";

import { InnerHtmlSVG } from "@common/InnerHtmlSVG";

import { openModal } from "@store/slices/sliceModal";

import { ReactComponent as ArrowLeft } from "@assets/images/arrow-left.svg";

import s from "./PaymentForm.module.css";

const PaymentForm = ({ onEnter, toggle, updateMethod, method }) => {
  const [summa, setSumma] = useState(0);
  const [tgId, setTgId] = useState(0);

  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [toggleDisabled, setToggleDisabled] = useState(false);

  const ref = useRef(null);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    onEnter(ref.current.offsetHeight);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current?.offsetHeight]);

  const handleSubmit = async () => {
    if (summa === 0 || tgId === 0) {
      return;
    }

    setSubmitDisabled(true);

    const paymentData = {
      method: method.name,
      sum: summa,
      tgId: tgId
    }

    try {
      const {data} = await postPaymentData(paymentData);
        window.location.href = data;
    } catch (err) {
      dispatch(openModal({ modalFatal: true }));
      setSubmitDisabled(false);
    }
  }

  const handleChangeSumma = useCallback((event) => {
    setSumma(event.target.value);
  }, []);

  const handleChangeTgId = useCallback((event) => {
    setTgId(event.target.value);
  }, []);

  return (
      <div className={s.paymentMethodContainer} ref={ref}>
        <div className={s.subTitle}>{t("Donat.field")}</div>
        <div className={s.bankCard}>
          <button disabled={toggleDisabled} onClick={() => {
            setToggleDisabled(true);
            toggle();
            updateMethod("");
          }} className={s.back}>
            <ArrowLeft className={s.arrowLeft}/>
          </button>

          <div className={s.headerBlock}>
            <div className={s.img}>
              {<InnerHtmlSVG svg={method.svg}/>}
            </div>

            <div className={s.bankCardText}>
              <div className={s.bankCardTitle}>
                {method.title}
              </div>
            </div>
          </div>

          <div className={s.inputList}>
            <input
                type="number"
                placeholder={t("Donat.id")}
                className={s.input}
                value={tgId === 0 ? '' : tgId}
                onChange={handleChangeTgId}
            />

            <input
                type="number"
                placeholder={t("Donat.summa")}
                className={s.input}
                value={summa === 0 ? '' : summa}
                onChange={handleChangeSumma}
            />
          </div>

          <button disabled={submitDisabled} onClick={handleSubmit} className={s.pay}>{t("Donat.payBtn")}</button>
        </div>
      </div>
  );
};

export default PaymentForm;
